import React, {
    useContext,
    useCallback,
    useState
} from 'react';
import { get } from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import metadata from './VehiclesPage.metadata.json5';
import styles from './VehiclesPage.module.scss';

function VehiclesPage(props) {
    const { wizardData: policyViewVM } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const [checkScrolling, setCheckScrolling] = useState(false);
    const [availableMakes, setAvailableMakes] = useState({});
    const [availableModels, setAvailableModels] = useState({});
    const [availableSeries, setAvailableSeries] = useState({});

    /**
     * Helper callback for handling navigation to the next wizard screen.
     */
    const onNext = useCallback(
        () => policyViewVM,
        [policyViewVM]
    );

    /**
     * Define property overrides for this Jutro component.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            readOnly: true,
            labelPosition: breakpoint === 'top',
        },
        vehiclesPageLoadingIndicator: {
            loaded: true,
        },
        vehiclesPageContainer: {
            visible: true
        },
        scrollingComponentId: {
            checkScrolling,
            setCheckScrolling,
            scrollableDiv: document.getElementById('vehicleGridContainer')
        },
        EAVehicleGrid: {
            vehicles: get(policyViewVM, 'lobData.personalAuto_EA.coverables.vehicles', []),
            path: 'lobData.personalAuto_EA.coverables.vehicles.children',
            onValidate: () => {},
            viewModelService,
            showErrors: false,
            policyState: get(policyViewVM, 'policyAddress.state.value.code'),
            vehiclePageDisregardFieldValidation: () => {},
            authHeader,
            onValidationChange: () => {},
            transactionVM: policyViewVM,
            updateWizardData: () => {},
            setCheckScrolling,
            addVehicleVM: () => {},
            viewOnlyMode: true,
            availableMakes,
            setAvailableMakes,
            availableModels,
            setAvailableModels,
            availableSeries,
            setAvailableSeries
        },
    };

    /**
     * Define mappings to be used when resolving values for this Jutro component.
     */
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onAddVehicleClick: () => { },
            onAddAdditionalInterest: () => { },
            onRemoveVehicle: () => { },
            onValidate: () => {},
            onPrefillData: () => { },
            onAddSafetyVehicleClick: () => { },
            onAddTemporarySafetyVM: () => { },
        },
    };

    /**
     * Helper callback for reading values from the view model.
     */
    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, policyViewVM, id, path, overrideProps),
        [policyViewVM, overrideProps]
    );

    /**
     * Define rendering behaviors for this Jutro component.
     */
    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyViewVM}
                overrideProps={overrideProps}
                resolveValue={readValue}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

VehiclesPage.propTypes = wizardProps;
export default VehiclesPage;
